export default __webpack_public_path__ + "static/media/00-sky.09912c11.png";